import React from 'react'
import InputField from '../../../../../FormControl/input/InputField'
import Typography from '@mui/material/Typography'
import { Chip, Divider } from '@mui/material'
import SelectCurriculum from '../../SelectCustom/SelectCurriculum'
import SelectMultipleField from '../../../../../FormControl/input/SelectMultipleField'
import SelectField from '../../../../../FormControl/input/SelectField'
import InputColor from '../../../../../FormControl/input/InputColor'
import SelectRatingType from '../../SelectCustom/SelectRatingType'

const FormSpecialCircumstances = ({ form = {}, errors = {}, onChange, type, curriculumList = [] }) => {
  const currentCurriculum = curriculumList?.find((item) => item._id === form?.curriculumId)
  return (
    <>
      <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
        Type
      </Typography>
      <div className='col-span-3'>
        <SelectRatingType
          onChange={(e) => onChange('type', e.target.value)}
          value={form.type}
          error={errors?.type}
          helperText={errors?.type}
          isPreview={type === 'preview'}
        />
      </div>
      <Divider className='col-span-full' />

      <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
        Code
      </Typography>
      <div className='col-span-3'>
        {type === 'preview' ? (
          <Typography>{form.code}</Typography>
        ) : (
          <InputField
            id='code'
            name='code'
            value={form.code}
            error={errors?.code}
            helperText={errors?.code}
            onChange={(e) => onChange('code', e.target.value)}
            fullWidth
            disabled={type === 'preview'}
          />
        )}
      </div>
      <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
        Name
      </Typography>
      <div className='col-span-3'>
        {type === 'preview' ? (
          <Typography>{form.name}</Typography>
        ) : (
          <InputField
            id='name'
            name='name'
            value={form.name}
            error={errors?.name}
            helperText={errors?.name}
            onChange={(e) => onChange('name', e.target.value)}
            fullWidth
            disabled={type === 'preview'}
          />
        )}
      </div>
      <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
        Description
      </Typography>
      <div className='col-span-3'>
        {type === 'preview' ? (
          <Typography>{form.description}</Typography>
        ) : (
          <InputField
            id='description'
            name='description'
            value={form.description}
            error={errors?.description}
            helperText={errors?.description}
            onChange={(e) => onChange('description', e.target.value)}
            fullWidth
            multiline={true}
          />
        )}
      </div>
      <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
        Primary Color
      </Typography>
      <div className='col-span-3'>
        <InputColor
          id='primaryColor'
          name='primaryColor'
          value={form.primaryColor}
          error={errors?.primaryColor}
          helperText={errors?.primaryColor}
          onChange={(value) => onChange('primaryColor', value)}
          fullWidth
          disabled={type === 'preview'}
        />
      </div>
      <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
        Secondary Color
      </Typography>
      <div className='col-span-3'>
        <InputColor
          id='secondaryColor'
          name='secondaryColor'
          value={form.secondaryColor}
          error={errors?.secondaryColor}
          helperText={errors?.secondaryColor}
          onChange={(value) => onChange('secondaryColor', value)}
          fullWidth
          disabled={type === 'preview'}
        />
      </div>

      {form.type === 'age-expected-scale' && (
        <>
          <Divider className='col-span-full' />
          <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
            Scale A-E
          </Typography>
          <div className='col-span-3'>
            {type === 'preview' ? (
              <Typography>{form.scaleAE}</Typography>
            ) : (
              <InputField
                id='scaleAE'
                name='scaleAE'
                value={form.scaleAE}
                error={errors?.scaleAE}
                type='number'
                helperText={errors?.scaleAE}
                onChange={(e) => onChange('scaleAE', e.target.value)}
                fullWidth
                disabled={type === 'preview'}
              />
            )}
          </div>
          <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
            Threshold
          </Typography>
          <div className='col-span-3'>
            {type === 'preview' ? (
              <Typography>{form.threshold}</Typography>
            ) : (
              <InputField
                id='threshold'
                name='threshold'
                value={form.threshold}
                error={errors?.threshold}
                type='number'
                helperText={errors?.threshold}
                onChange={(e) => onChange('threshold', e.target.value)}
                fullWidth
                disabled={type === 'preview'}
              />
            )}
          </div>
        </>
      )}
    </>
  )
}

export default FormSpecialCircumstances
